import '@backstage/cli/asset-types';
import '@backstage/ui/css/styles.css';
import { createRoot } from 'react-dom/client';
import { AppRoot } from './app';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<AppRoot />);
